import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {
  GonvarriProgramClientTableComponent
} from "../../components/gonvarri-program-client-table/gonvarri-program-client-table.component";
import {AddToCartModule} from "@spartacus/cart/base/components/add-to-cart";
import {AppModule} from "../../app.module";
import {GonvarriAddToCartModule} from "../gonvarri-add-to-cart/gonvarri-add-to-cart.module";
import {
  GonvarriQuickStockTitleModalModule
} from "../gonvarri-quick-stock-title-modal/gonvarri-quick-stock-title-modal.module";
import {QuickOrderListModule} from "@spartacus/cart/quick-order/components";



@NgModule({
  declarations: [
    GonvarriProgramClientTableComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    GonvarriAddToCartModule,
    GonvarriQuickStockTitleModalModule,
    QuickOrderListModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriProgramClientTableComponent: {
          component: GonvarriProgramClientTableComponent
        }
      }
    })
  ]
})
export class GonvarriProgramClientTableModule { }
